module.exports = __webpack_public_path__ + "static/media/65.d043730b.png";